import { render, staticRenderFns } from "./ChooseUser.vue?vue&type=template&id=37741747&"
import script from "./ChooseUser.vue?vue&type=script&lang=js&"
export * from "./ChooseUser.vue?vue&type=script&lang=js&"
import style0 from "./ChooseUser.vue?vue&type=style&index=0&id=37741747&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports